export enum Types {
  MOVIE = 'MOVIE',
  EPISODE = 'EPISODE',
  SEASON = 'SEASON ',
  SERIES = 'SERIES ',
  PROGRAM = 'PROGRAM',
}
